import { FC, useMemo } from "react";
import ProjectSections from "./ProjectSection";
import { openInfoPage } from "../common/stringUtil";
import PieChart from "../../components/PieChart";

type props = { infoPrjDataAmountMap: any[] };

const ROW_H = 47;
const HEADER_H = 57;

const ProjectManage14: FC<props> = ({ infoPrjDataAmountMap }) => {
  const projectDat = useMemo(
    () =>
      (infoPrjDataAmountMap || []).map((p: any) => ({
        name: p.PRJ_NM,
        value: Number(p.USE_AMOUNT) || 0,
      })),
    [infoPrjDataAmountMap]
  );

  const dynamicH = ROW_H * (infoPrjDataAmountMap?.length || 0) + HEADER_H;
  const chartSize = Math.max(240, Math.min(320, dynamicH)); // 240~320

  return (
    <ProjectSections
      title="프로젝트별 데이터 사용량"
      className="user-porject-data"
      onButtonClick={() => openInfoPage("P001")}
      buttonClassName="icon--more"
    >
      {/* === flex 2컬럼: 세로 정렬을 center로 === */}
      <div
        style={{
          display: "flex",
          gap: 12,
          alignItems: "center", // ▼ 테이블을 차트의 세로 중앙으로
        }}
      >
        {/* 좌측: 파이 차트 컬럼 */}
        <div
          style={{
            width: "40%",
            minWidth: 260,
            padding: "8px 0 8px 36px", // 라벨(.82) 공간
            boxSizing: "border-box",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "right",
            height: chartSize,        // ▼ 차트 높이 고정 → 중앙 정렬 기준
            overflow: "visible",
          }}
        >
          {projectDat.length > 0 ? (
            <div style={{ width: chartSize*7, height: chartSize }}>
              <PieChart width={chartSize*7} height={chartSize} data={projectDat} />
            </div>
          ) : null}
        </div>

        {/* 우측: 표 컬럼 (차트 높이만큼의 최소 높이 확보 후 중앙정렬) */}
        <div
          style={{
            flex: 1,
            minHeight: chartSize,     // ▼ 차트 높이 기준
            display: "flex",
            alignItems: "center",     // ▼ 표를 세로 가운데 배치
          }}
        >
          <ul className="board-table user-tbl" style={{ width: "100%", margin: 0 }}>
            <li className="thead">
              <span className="col-th">프로젝트명</span>
              <span className="col-th">파일수(개)</span>
              <span className="col-th">사용 용량(MB)</span>
            </li>
            {infoPrjDataAmountMap && infoPrjDataAmountMap.length > 0 ? (
              infoPrjDataAmountMap.map((item: any, idx: number) => (
                <li className="tbody" key={`${item.PRJ_NM}-${idx}`}>
                  <span className="col-td" style={{ verticalAlign: "middle" }}>{item.PRJ_NM}</span>
                  <span className="col-td" style={{ verticalAlign: "middle" }}>{item.FILE_CNT}</span>
                  <span className="col-td" style={{ verticalAlign: "middle" }}>{item.USE_AMOUNT}</span>
                </li>
              ))
            ) : (
              <li className="empty">조회된 결과가 없습니다.</li>
            )}
          </ul>
        </div>
      </div>
    </ProjectSections>
  );
};

export default ProjectManage14;
